import listActions from 'src/modules/quiz/list/quizListActions';
import QuizService from 'src/modules/quiz/quizService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'QUIZ_UNARCHIVE';

const quizUnarchiveActions = {
  UNARCHIVE_STARTED: `${prefix}_UNARCHIVE_STARTED`,
  UNARCHIVE_SUCCESS: `${prefix}_UNARCHIVE_SUCCESS`,
  UNARCHIVE_ERROR: `${prefix}_UNARCHIVE_ERROR`,

  UNARCHIVE_ALL_STARTED: `${prefix}_UNARCHIVE_ALL_STARTED`,
  UNARCHIVE_ALL_SUCCESS: `${prefix}_UNARCHIVE_ALL_SUCCESS`,
  UNARCHIVE_ALL_ERROR: `${prefix}_UNARCHIVE_ALL_ERROR`,

  doUnarchive: (id) => async (dispatch) => {
    try {
      dispatch({
        type: quizUnarchiveActions.UNARCHIVE_STARTED,
      });

      await QuizService.unarchiveAll([id]);

      dispatch({
        type: quizUnarchiveActions.UNARCHIVE_SUCCESS,
      });

      Message.success(
        i18n('entities.quiz.unarchive.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/quiz');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: quizUnarchiveActions.UNARCHIVE_ERROR,
      });
    }
  },

  doUnarchiveAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type:
          quizUnarchiveActions.UNARCHIVE_ALL_STARTED,
      });

      await QuizService.unarchiveAll(ids);

      dispatch({
        type:
          quizUnarchiveActions.UNARCHIVE_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.quiz.unarchiveAll.success'),
      );

      getHistory().push('/quiz');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type:
          quizUnarchiveActions.UNARCHIVE_ALL_ERROR,
      });
    }
  },
};

export default quizUnarchiveActions;
